export default "//static.tradera.net/touchweb/static/output/images/category-hobby.0dd05544.svg";